import React, { useCallback, useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import Icon from 'react-icons-kit'
import { chevronLeft } from 'react-icons-kit/feather'
import Requests from '../../../../utils/Requests/Index'

import LoadingComponent from '../../../../components/loading/Index'

const Show = () => {
    const { id } = useParams()
    const [isLoading, setLoading] = useState(true)
    const [item, setItem] = useState(null)
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })

    // Fetch data
    const fetchData = useCallback(async () => {
        const data = await Requests.ExpertCounselorsProfile.Show(id, header)
        if (data) {
            setItem(data)
            setLoading(false)
        }
        setLoading(false)
    }, [id, header])


    useEffect(() => {
        fetchData()
    }, [id, header, fetchData])


    if (isLoading) return <LoadingComponent />

    return (
        <div className="store-blog pb-4">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header p-3 p-lg-4 bg-white">
                                <div className="d-flex justify-content-between">
                                    <div><h6 className="mb-0">Show Expert Counselors Profile</h6></div>
                                    <div className="ml-auto">
                                        <Link
                                            to="/dashboard/website/expert-counselors-profile"
                                            type="button"
                                            className="btn shadow-none rounded-circle"
                                        >
                                            <Icon icon={chevronLeft} size={22} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-4">
                                <div className="d-lg-flex">
                                    <div className="pr-lg-5 mb-4">
                                        <img
                                            src={item.image}
                                            className="img-fluid"
                                            alt="..."
                                            style={{ width: 200 }}
                                        />
                                    </div>
                                    <div>
                                        <table className="table table-md table-borderless">
                                            <tbody>
                                                <tr>
                                                    <td>Name</td>
                                                    <td>{item.name || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <td>Expert</td>
                                                    <td>{item.expert || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <td>Features </td>
                                                    <td><div className="list-unstyled ml-3">{item.features?.map((f, j) => <div key={j}><li>{f}</li></div>)}</div></td>
                                                </tr>

                                                <tr>
                                                    <td>Social </td>
                                                    <td>facebook: {item.social?.facebook || 'N/A'}</td>
                                                    <td>instagram: {item.social?.instagram || 'N/A'}</td>
                                                    <td>linkedin: {item.social?.linkedin || 'N/A'}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <br />

                                {item.admin ?
                                    <div className="text-end">
                                        <h6><i>Created by</i></h6>
                                        <p className="mb-0">{item.admin.name}</p>
                                        <p className="mb-0">{item.admin.email}</p>
                                    </div>
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Show;